import { Flex, Text, List, ListItem } from '@chakra-ui/react';
import { Badge, Link } from '@morressier/alembic';
import { OrcidIcon } from '../Submission/AuthorsTab/AuthorInfo';
import { getOrcidUrl } from '../../utils/utils';

type RenderSectionDetailsProps = {
  label: string;
  value?: string | string[] | null;
  type?: string;
};

type RenderOrcidIconProps = {
  value: string;
};

export const OrcidIDIcon = ({ value }: RenderOrcidIconProps) => {
  const orcidUrl = getOrcidUrl(value);

  return orcidUrl ? (
    <Link isExternal variant="primary" href={orcidUrl}>
      <OrcidIcon />
    </Link>
  ) : (
    <OrcidIcon />
  );
};

export const RenderSectionDetails = ({
  label,
  value,
  type
}: RenderSectionDetailsProps) => {
  const hasArrayValues =
    Array.isArray(value) &&
    value.length > 0 &&
    value.some(v => v && v.trim() !== '');
  const hasStringValue =
    typeof value === 'string' &&
    value.trim() !== '' &&
    value !== 'Invalid Date';

  return (
    <Flex direction="column" gap={1}>
      <Text textStyle="headingItem">{label}</Text>

      {hasArrayValues ? (
        type === 'bullet' ? (
          <List spacing={1} styleType="disc" stylePosition="inside">
            {(value as string[]).map((val, idx) => (
              <ListItem key={idx}>{val}</ListItem>
            ))}
          </List>
        ) : (
          <Flex gap={2} wrap="wrap">
            {(value as string[]).map((val, idx) => (
              <Badge whiteSpace={'normal'} key={idx}>
                {val}
              </Badge>
            ))}
          </Flex>
        )
      ) : hasStringValue && type === 'orcid' ? (
        <Flex alignItems={'center'} gap={1}>
          <OrcidIDIcon value={value} />
          <Text>{value}</Text>
        </Flex>
      ) : hasStringValue && type === 'url' ? (
        <Link href={value} variant="primary" target="_blank">
          {value}
        </Link>
      ) : hasStringValue ? (
        <Text>{value}</Text>
      ) : (
        <Text textStyle="textBody" color="GrayText">
          No data available
        </Text>
      )}
    </Flex>
  );
};
